import { cn } from "@/lib/utils";

interface ChevronRightIconProps {
  className?: string;
}

export default function ChevronRightIcon({ className }: ChevronRightIconProps) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-6 w-6 text-gray-400", className)}
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}
